import { render, staticRenderFns } from "./company_record.vue?vue&type=template&id=18d9ee13"
import script from "./company_record.vue?vue&type=script&lang=js"
export * from "./company_record.vue?vue&type=script&lang=js"
import style0 from "./company_record.vue?vue&type=style&index=0&id=18d9ee13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports